<template>
    <div id = "prizes">
        <div class = "firstLayer">
            <img :src="centralPiece" />
        </div>
        <div class = "secondLayer">
            <div class = "main">
                <h1 class = "category-title"> MAIN </h1>
                <div class = "companies">
                    <h1 class = "category-title"> Google </h1>
                    <h1 class = "category-title"> Bitdefender </h1>
                    <h1 class = "category-title"> B/Programmer </h1>
                </div>
                <div class = "podium">
                    <div class = "podium-row">
                        <img :src="firstPlace" />
                    </div>
                    <div class = "podium-row">
                        <img :src="secondPlace" />
                        <img :src="thirdPlace" />
                    </div>
                </div>
            </div>
            <div class = "side">
                <h1 class = "category-title"> SIDE </h1>
                <div class = "side-content">
                    <div class = "side-companies">
                        <div v-for ="(company, index) in companies" :key="index" class = "side-company">
                            <h2 class = "side-company-title"> {{company}} </h2>
                            <img :src="sideCompanyPoint">
                        </div>
                    </div>
                    <div class = "side-prizes">
                        <img :src="firstPlaceSide">
                        <img :src="secondPlaceSide">
                        <img :src="thirdPlaceSide">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            centralPiece: "https://i.imgur.com/wJJddJS.png",
            firstPlace: "https://i.imgur.com/DfFvWBs.png",
            secondPlace: "https://i.imgur.com/K6C7fY1.png",
            thirdPlace: "https://i.imgur.com/yVnPiBM.png",
            firstPlaceSide: "https://i.imgur.com/440gVtE.png",
            secondPlaceSide: "https://i.imgur.com/25jaLTB.png",
            thirdPlaceSide: "https://i.imgur.com/N7Cgyju.png",
            sideCompanyPoint: "https://i.imgur.com/mCKCmch.png",
            companies: ["ORTEC", "BCR", "ENEVO", "UiPath"]
        }
    }
}
</script>

<style lang="scss" scoped>
#prizes {
    background-image: url('https://i.imgur.com/R0fBS0W.png');
    background-size: cover;
    height: 100vh;
    position: relative;
    display: flex;
}

.firstLayer {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.secondLayer {
    display: flex;
    position: absolute;
    height: 100%;
    width: 100%;
}

.main, .side {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 50%;
    justify-content: flex-start;
    align-items: center;
    padding-top: 2%;
}

.category-title {
    color: #fff;
}

.companies {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 50px;
    width: 100%;
}

.companies > h1 {
    margin-right: 50px;
    margin-left: 50px;
    font-weight: 500;
}

.podium {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.podium-row {
    display: flex;
}

.podium-row:first-child {
    justify-content: center;
}

.podium-row:last-child {
    margin-top: 20px;
    justify-content: space-evenly;
    width: 70%;
}

.podium-row > img {
    height: 200px;
}

.side {

    &-content {
        display: flex;
        height: 60%;
        margin-top: 50px;
        width: 30%;
        justify-content: space-around;
    }

    &-companies {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-evenly;
    }

    &-company {
        display: flex;
        flex-direction: column;
        align-items: center;

        &-title {
            font-size: 20px;
            color: #fff;
            font-weight: 500;
        }

        & > img {
            width: 43px;
        }
    }

    &-prizes {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        &-img {
            height: 50px;
        }
    } 
}

@media screen and (min-width: 600px) and (max-height: 800px) {
    .podium-row > img {
        height: 120px;
        width: 120px;
        margin-top: 10px;
    }
    .category-title {
        font-size: 30px;
    }
    .podium {
        margin-top: 30px;
    }
}

@media screen and (max-width: 600px) {
    .firstLayer > img {
        width: 80px;
        display:none;
    }

    .companies > h1 {
        font-size: 20px;
    }

    .podium-row {
        flex-direction: column;
        align-items: center;
        width: 100% !important;
        margin-top: 0 !important;
    }

    .podium-row > img {
        height: 100px;
        width: 100px;
        margin-top: 10px;
    }

    .podium {
        margin-top: 50px;
    }

    .side-companies {
        justify-content: space-between;
    }

    .side-content {
        width: 80%;
        justify-content: space-around;
    }

    .side-prizes > img {
        height: 60px;
    }
}
</style>
